<!--
 * @Author: your name
 * @Date: 2021-11-10 23:27:16
 * @LastEditTime: 2022-05-21 14:57:57
 * @LastEditors: liuwujiang@easyretailpro.com liuwujiang@easyretailpro.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\App.vue
-->
<template>
<div id="app">
  <keep-alive v-if="$route.meta.keepAlive">
    <router-view></router-view>
  </keep-alive>
  <router-view v-else></router-view>
</div>
</template>

<script>
export default {
  name: 'app',
  components: {},
  computed: {},
  data() {
    return {}
  },
  created: function () {
    let payload = {}
    payload.openInWechat = this.$app.openInWeChat()
    payload.openInIOS = this.$app.openInIOS()
    this.$store.dispatch('SetSystemSetting', payload)
    this.$store.dispatch('SetWindowSize', {
      height: document.documentElement.clientHeight
    })
  },
  mounted() {},
  methods: {},
}
</script>

<style>
body {
  font-size: 16px;
  background-color: rgba(255, 255, 255, 1);
  -webkit-font-smoothing: antialiased;
}

.container {
  width: 100%;
  min-height: calc(100vh - 108px);
  background: rgba(255, 255, 255, 1);
  padding-bottom: 50px;
  overflow-x: hidden;
  box-sizing: border-box;
}

.van-tabbar--fixed {
  box-shadow: 0 4px 16px 0 rgba(67, 90, 133, 0.12);
}
</style><style lang="less">
.custom-table-wrap {
  background: #FFFFFF;
  box-shadow: 0 4px 16px 0 rgba(67, 90, 133, 0.12);
  border-radius: 8px;
  padding: 14px;

  .inside-tabs {
    line-height: 32px;
    font-size: 14px;
    margin-bottom: 12px;

    span {
      display: inline-block;
      width: 76px;
      font-weight: bold;
      text-align: center;
      color: #7A8CAC;
    }

    .active {
      background: #4574C8;
      border-radius: 6px;
      color: #fff;
    }
    .creat-code{
            font-size: 11px;
color: #4A5569;
float: right;
background: #FAFAFB;
border: 1px solid #E1E4E8;
border-radius: 20px;
width: 90px;
display:block;
line-height: 24px;
margin-top: 6px;
        }
  }

  table {
    width: 100%;
    text-align: center;

    th {
      background: #DCE3EE;
      height: 38px;
      color: #07378B;
      font-size: 14px;
      box-sizing: border-box;
    }

    td {
      background: #F3F6F8;
      height: 38px;
      color: #4A5569;
      font-size: 12px;

      box-sizing: border-box;

      .roi {
        color: #4574C8;
        text-decoration: underline;
      }
      
    }
    .alink{
        color: #4574C8;
        text-decoration: underline;
      }
    .score.lays {
      background: #FFF1CF;
      color: #2C2C2C;
    }

    .score.be-cheery {
      background: #FAEAEC;
      color: #2C2C2C;
    }

    .score.quaker {
      background: #C6D3EC;
      color: #2C2C2C;
    }

    .white {

      td {
        background: #fff;
        height: 30px;
        font-size: 12px;
      }
    }
    .view,.tdm-view {
        background: #4574C8;
        border-radius: 13px;
        color: #fff;
        // width: 80px;
        line-height: 26px;
        margin: 0 3px;
      }
    .flex-space-between {
      display: flex;
      justify-content: space-between;

      span {
        width: 50px;
        line-height: 22px;
        border-radius: 22px;
        display: inline-block;
        margin-right: 6px;
        font-size: 11px;
      }

      .lays {
        color: #E68700;
        border: 1px solid #E68700;
      }
      .lays.active{
        background: #E68700;
        color:#fff;
      }

      .quaker {
        color: #0D295A;
        border: 1px solid #0D295A;
      }
      .quaker.active{
        background: #0D295A;
        color:#fff;
      }
      .be-cheery {
        color: #CA0313;
        border: 1px solid #CA0313;
      }
      .be-cheery.active{
        background: #CA0313;
        color:#fff;
      }

    
    }
  }
  .tdm {
    .flex-space-between {
      span{
        position: relative;
        width: 60px;
        &::before{
          width:3px;
          height: 3px;
          border-radius: 50%;
          position: absolute;
          top:50%;
          margin: -3px 0 0 0;
          left:5px;
          content:"";
        }
      }
      .quaker{
        &::before{
          border:1px solid #0D295A;
        }
      }
      .be-cheery{
        &::before{
          border:1px solid #CA0313;
        }
      }
      .lays{
        &::before{
          border:1px solid #E68700;
        }
      }
      .active{
        &::before{
          border:1px solid #fff;
          background: #fff;
        }
      }
    }

}
}

.highlight{
  position: relative;
  z-index:2;
}
.highlight::before{
  position: absolute;
  width: 104%;
  height: 100%;
  top:0;
  left: 0;
  margin: 0 -2% ;
  background: #DAE8F6;
  content:"";
  z-index:-1;
}
.options .van-cell{
  padding:0!important;
}
.options .van-field__control{
  background: #FCFDFF;
    border: 1px solid #D7DEE3;
    padding: 0 8px;
    font-size: 14px;
    color: #4A5569;
    line-height: 36px;
}
.province .value-item .input{
  width:100%!important;
}
.van-empty__image{
  height: auto!important;
    width: auto!important;
}
.van-tabbar--fixed{
  z-index:99!important;
}
</style>
